import request from '@/utils/request';


// 获取列表
export function GetList() {
  return request({
    url: '/api/user/address/page',
    method: 'GET',
  });
}

// 保存
export function Save(data) {
  return request({
    url: '/api/user/address/save',
    method: 'POST',
    data
  });
}

// 修改
export function Edit(data) {
  return request({
    url: '/api/user/address/edit',
    method: 'POST',
    data
  });
}

// 删除
export function Delete(params) {
  return request({
    url: '/api/user/address/delete',
    method: 'GET',
    params: params
  });
}

// 详情
export function Detail() {
  return request({
    url: '/api/user/address/detail',
    method: 'GET',
  });
}

// 设为默认地址
export function SetDefault(data) {
  return request({
    url: '/api/user/address/setDefault',
    method: 'POST',
    data
  });
}

// 搜索详细地址
export function FuzzyMatching(params) {
  return request({
    url: '/api/user/address/fuzzyMatching',
    method: 'GET',
    params: params
  });
}
